// src/components/Home.js
import React from 'react';
import { FaCalendarAlt, FaHome, FaUserCircle, FaCalendarPlus, FaCrown, FaClipboardList, FaSignOutAlt } from 'react-icons/fa';
import '../App.css';

// Helper per gestire i percorsi delle immagini in caso di deploy su sottocartella (es. civiclab.it/PrenotaSpazi)
const getPublicPath = (p) => {
  const base = window.location.pathname.startsWith('/PrenotaSpazi') ? '/PrenotaSpazi' : '';
  return `${base}/${p.replace(/^\.\//, '').replace(/^\//, '')}`;
};

function Home({ onLoginClick, onRegisterClick, user, userData, onLogout, onSpacesClick, onProfileClick, onBookingClick, onSuperuserClick, onAdminClick, onCalendarClick }) {
  const backgroundStyle = {
    // Foto DoMi
    
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // <--- IMPORTANTE: Spinge il footer in basso
    fontFamily: "'Poppins', sans-serif"
  };

  const cardButtonStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px',
    borderRadius: '15px',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    cursor: 'pointer',
    textAlign: 'center',
    gap: '10px',
    border: 'none',
    color: '#333',
    textDecoration: 'none',
    fontSize: '14px',
    height: '100%',
    boxSizing: 'border-box'
  };

  return (
    <div style={backgroundStyle}>

      {/* NAVBAR */}
      <div className="glass-panel home-nav responsive-nav" style={{ borderRadius: '50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxSizing: 'border-box' }}>
        <div style={{ fontWeight: 'bold', fontSize: '22px', color: '#222', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ background: '#222', color: 'white', padding: '5px 10px', borderRadius: '8px', fontSize: '14px' }}>CIVIC</div>
        </div>

        <div className="responsive-nav-actions" style={{ display: 'flex', gap: '10px' }}>
          {!user ? (
            <>
              <button onClick={onLoginClick} className="nav-btn btn-filled">
                Accedi
              </button>

              <button onClick={onRegisterClick} className="nav-btn btn-outline">
                Registrati
              </button>
            </>

          ) : (
            <div className="responsive-nav-actions" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              {userData && userData.role === 'superuser' && (
                <button
                  onClick={onSuperuserClick}
                  className="nav-icon-btn"
                  title="Dashboard Superuser"
                  style={{
                    background: '#222', color: '#FFD700', border: '2px solid #FFD700',
                    padding: '8px 20px', borderRadius: '30px', cursor: 'pointer', fontWeight: 'bold',
                    display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 0 10px rgba(255, 215, 0, 0.3)'
                  }}
                >
                  <FaCrown size={20} /> <span className="nav-desktop-text">Dashboard Superuser</span>
                </button>
              )}
              {(userData?.role === 'admin' || userData?.role === 'superuser') && (
                <button
                  onClick={onAdminClick}
                  className="nav-icon-btn"
                  title="Gestione Prenotazioni"
                  style={{
                    background: '#222', color: 'white', border: '1px solid #fff',
                    padding: '8px 20px', borderRadius: '30px', cursor: 'pointer', fontWeight: 'bold',
                    display: 'flex', alignItems: 'center', gap: '8px'
                  }}
                >
                  <FaClipboardList size={20} /> <span className="nav-desktop-text">Gestione Prenotazioni</span>
                </button>
              )}
              <div
                onClick={onProfileClick}
                className="nav-icon-btn"
                title="Vai al tuo profilo"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(255,255,255,0.5)', // Sfondo vetro
                  padding: '8px 20px',
                  borderRadius: '30px',
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.8)'} // Effetto hover
                onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.5)'}
              >
                <FaUserCircle size={24} color="#222" />
                <span className="nav-desktop-text" style={{ fontWeight: 'bold', color: '#333' }}>
                  {user.email}
                </span>
              </div>

              {/* 2. BOTTONE LOGOUT (Rosso e staccato) */}
              <button
                onClick={onLogout}
                style={{
                  background: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%', // Perfettamente rotondo
                  width: '36px',
                  height: '36px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  transition: 'transform 0.2s, background 0.2s'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.background = '#c82333'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.background = '#dc3545'; }}
                title="Esci"
              >
                <FaSignOutAlt size={16} style={{ marginLeft: '3px' }} />
              </button>

            </div>
          )}
        </div>
      </div>

      {/* --- BODY CENTRALE --- */}
      <div className="home-main-body" style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', boxSizing: 'border-box' }}>


        <div className="glass-panel" style={{ padding: '30px', paddingBottom: '40px', borderRadius: '30px', maxWidth: '900px', width: '100%', textAlign: 'center', boxSizing: 'border-box' }}>
          <h1 className="home-main-title">
            Gestione spazio
          </h1>
          <p className="home-sub-title">
            CIVIC - Laboratorio Innovazione Urbana
          </p>

          <div className="home-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', width: '100%' }}>

            <div className="glass-card-button" style={cardButtonStyle} onClick={onBookingClick}>
              <FaCalendarPlus size={35} color="#e91e63" />
              <div>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '16px' }}>Nuova Prenotazione</h3>
                <span style={{ color: '#444', fontSize: '12px' }}>Compila e prenota</span>
              </div>
            </div>

            <div className="glass-card-button" style={cardButtonStyle} onClick={onCalendarClick}>
              <FaCalendarAlt size={35} color="#6f42c1" />
              <div>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '16px' }}>Calendario</h3>
                <span style={{ color: '#444', fontSize: '12px' }}>Consulta date</span>
              </div>
            </div>

            <div className="glass-card-button" style={cardButtonStyle} onClick={onSpacesClick}>
              <FaHome size={35} color="#28a745" />
              <div>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '16px' }}>Info Spazi</h3>
                <span style={{ color: '#444', fontSize: '12px' }}>Dettagli tecnici</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="home-footer" style={{
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}>

        <a
          href="https://www.civiclab.it/"
          target="_blank"
          rel="noreferrer"
          className="glass-panel home-footer-link"
          style={{
            color: '#222',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: '50px',
            fontWeight: '600'
          }}
        >
          <img
            src={getPublicPath("logo1.jpg")}
            alt="Logo Civic"
            className="home-footer-img"
            style={{
              borderRadius: '50%',
              objectFit: 'contain' 
            }}
          />
          Homepage
        </a>

        <a
          href="https://www.instagram.com/coding_cafe.py/"
          target="_blank"
          rel="noreferrer"
          className="glass-panel home-footer-link"
          style={{
            color: '#222',
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: '50px',
            fontWeight: '600'
          }}
        >
          <img
            src={getPublicPath("logo_codcaf.jpg")}
            alt="Coding Cafe Logo"
            className="home-footer-img"
            style={{
              borderRadius: '50%', 
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)' 
            }}
          />

          by Coding Cafe
        </a>

      </div>
    </div>
  );
}

export default Home;